import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const Logout = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '24',
    strokeAsPrimary: true,
    style,
  });

  return (
    <svg
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      viewBox='0 0 25 24'
    >
      <path
        d='M9.06256 21H5.06256C4.53213 21 4.02342 20.7893 3.64835 20.4142C3.27327 20.0391 3.06256 19.5304 3.06256 19V5C3.06256 4.46957 3.27327 3.96086 3.64835 3.58579C4.02342 3.21071 4.53213 3 5.06256 3H9.06256M16.0626 17L21.0626 12M21.0626 12L16.0626 7M21.0626 12H9.06256'
        stroke={primaryColorToUse}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
